module.exports = __webpack_public_path__ + "img/macif.36adf3f3.jpg";